import styled from 'styled-components'

const Flag = styled.span`
  display: block;
  cursor: pointer;
`
export { Flag } //eslint-disable-line
